export default __webpack_public_path__ + "53bcd58ed6fd689731795f1f9c6d583e.png";